import { Injectable } from '@angular/core';
import { SigningServiceHttp } from '../signing-service';
import { Observable } from 'rxjs';
import { ActivityLogs } from '../signing-sidebar/activity-logs/activity-logs-dto';

@Injectable({
  providedIn: 'root'
})
export class RegisteredEventsService {

  constructor(private http: SigningServiceHttp) { }

  /**
   * get the registered events
   * @role_id
   * @returns 
   */
  getRegisteredEvents(role_id:string): Observable<ActivityLogs[]>{
    return this.http.get(`sign-document/${role_id}/activity-log`);
  }
}
